import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Form } from '@crisellevaldez/speculo-ui';
import { MessageSquare, Info } from 'lucide-react';
import { BrandingFormData } from '../../../../../schemas/branding.schema';
import { FormattedTextarea } from '../../../../common/FormattedTextarea';
import { IconPill } from '../../../../common/IconPill';

interface SqueezePageSectionProps {
  control: Control<BrandingFormData>;
}

export const SqueezePageSection: React.FC<SqueezePageSectionProps> = ({ control }) => {
  return (
    <div className="bg-gray-50 dark:bg-white/5 rounded-lg p-6 border border-gray-300 dark:border-white/15">
      <div className="flex items-center gap-3 mb-3">
        <IconPill icon={MessageSquare} />
        <h4 className="text-sm font-bold text-foreground">Squeeze Page Settings</h4>
      </div>

      <hr className="dark:border-white/10" />

      <div className="mt-5">
        <Form.Control>
          <Form.Label>Custom Opt-In Language</Form.Label>
          <Controller
            name="squeezePage.language"
            control={control}
            render={({ field }) => (
              <FormattedTextarea
                value={field.value || ''}
                onChange={field.onChange}
                placeholder="Enter custom opt-in language..."
                rows={4}
              />
            )}
          />
          <div className="mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-md border border-blue-200 dark:border-blue-700/30">
            <div className="flex items-start gap-2">
              <Info className="w-4 h-4 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
              <div className="text-xs text-blue-700 dark:text-blue-300">
                <p className="font-medium mb-1">Autopopulate Tags:</p>
                <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                  <div>
                    <code className="bg-blue-100 dark:bg-blue-800/40 px-1 rounded">{'{yyyy}'}</code> - Current year
                  </div>
                  <div>
                    <code className="bg-blue-100 dark:bg-blue-800/40 px-1 rounded">{'{mm/dd/yyyy}'}</code> - Date
                  </div>
                  <div>
                    <code className="bg-blue-100 dark:bg-blue-800/40 px-1 rounded">{'{privacy_link}'}</code> - Privacy
                    policy link
                  </div>
                  <div>
                    <code className="bg-blue-100 dark:bg-blue-800/40 px-1 rounded">{'{terms_of_use_link}'}</code> -
                    Terms link
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form.Control>
      </div>
    </div>
  );
};
